<template>
    <div>
        <el-date-picker
                class="mr-2"
                v-model="datePreorders"
                value-format="yyyy-MM-dd"
                format="dd.MM.yyyy"
                type="date"
                placeholder="Выбрать день">
        </el-date-picker>
        <b-button class="mr-5" variant="success" @click="printPreorders">Печать предзаказов</b-button>
    </div>
</template>

<script>
import graphqlLogistian from '../graphql/logistian'
export default {
  name: 'PreordersPrintPicker',
  data () {
    return {
      datePreorders: this.$moment().add(1, 'days').format('YYYY-MM-DD')
    }
  },
  methods: {
    printPreorders () {
      this.$apollo.mutate({
        mutation: graphqlLogistian.PRINT_PREORDERS,
        variables: {
          date: this.datePreorders
        }
      }).then((data) => {
        // console.log(data)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PreordersPrintPicker.vue